module.exports = __webpack_public_path__ + "static/img/waves-welcome.71feb05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/waves-welcome.png
// module id = rD0R
// module chunks = 0